import { render, staticRenderFns } from "./Func5BuscaMedicamentos.vue?vue&type=template&id=cff7029e"
import script from "./Func5BuscaMedicamentos.vue?vue&type=script&lang=js"
export * from "./Func5BuscaMedicamentos.vue?vue&type=script&lang=js"
import style0 from "./Func5BuscaMedicamentos.vue?vue&type=style&index=0&id=cff7029e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports